import React from 'react'
import { Button, SectionHeader } from '@base'
import styled from 'styled-components'
import { Spacings, Text } from '@styles'
import { DRAWER_TYPES, strings } from '@constants'
import { Add } from '@material-ui/icons'
import { useDispatch } from 'react-redux'
import { toggleDrawer } from '@data/state/action/root'
import { capitalizeWord } from '@utils'

export const PaymentTermsHeaader = styled(SectionHeader)`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	& > button {
		min-height: 0;
		height: fit-content;
		min-width: 0;
		width: fit-content;
	}
	margin-top: ${({ PaddedHeading }) => PaddedHeading && Spacings.SPACING_6B};
`
export const PaddedWrapper = styled.div`
	padding: ${Spacings.SPACING_2B} 0;
`
export const TextListWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_2B};
	& > div {
		font-size: ${Text.MEDIUM};
		font-weight: ${Text.BOLD_600};
		color: ${({ theme }) => theme.palette.background.borderColor};
	}
`

const PaymentTerms = ({ state2, valueChangeHandler }) => {
	const globalDispatch = useDispatch()
	const callbackFunction = (_paymentTermsList) => {
        valueChangeHandler(null, 'payment_terms_list')(_paymentTermsList)
        globalDispatch(toggleDrawer(false))
	}

	const editPaymentTerms = () => {
		globalDispatch(
			toggleDrawer(true, DRAWER_TYPES.EDIT_PAYMENT_TERMS, {
				label: strings('payment_terms'),
				enquiry: state2?.enquiry,
				edit: true,
				callbackFunction,
				data: state2?.enquiryQuote?.payment_terms_list,
			})
		)
	}
	return (
		<PaddedWrapper>
			<PaymentTermsHeaader>
				<span>{strings('payment_terms')}</span>
				<Button xs primary onClick={editPaymentTerms}>
					<Add fontSize='small' />
				</Button>
			</PaymentTermsHeaader>
			<TextListWrapper>
				{state2?.enquiryQuote?.payment_terms_list?.map((item) => {
					return (
						<div>
							{`${item?.percentage}% ${capitalizeWord(item?.payment_term)} ${item?.condition
								?.split('_')
								?.map((item) => capitalizeWord(item))
								?.join(' ')} for ${item?.tenure_in_days} days`}
						</div>
					)
				})}
			</TextListWrapper>
		</PaddedWrapper>
	)
}

export default PaymentTerms
